import { render, staticRenderFns } from "./noticeAndInfo.vue?vue&type=template&id=de451c7a&scoped=true"
import script from "./noticeAndInfo.vue?vue&type=script&lang=js"
export * from "./noticeAndInfo.vue?vue&type=script&lang=js"
import style0 from "./noticeAndInfo.vue?vue&type=style&index=0&id=de451c7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de451c7a",
  null
  
)

export default component.exports